import { useState } from "react";
import { canvasMedicationOptions, useCanvasMedicationsQuery, useMedicationLookup } from "@tellescope/tanstack-query";
import { CANVAS_TITLE } from "@tellescope/constants";
import { useDebouncedValue } from "@tellescope/react-hooks";

export interface UseMedicationCatalogArgs {
  selectedDisplayName: string;
  selectedSpecificDrugName: string;
  dataSource?: string;
}

export const useMedicationCatalog = ({
  selectedDisplayName,
  selectedSpecificDrugName,
  dataSource,
}: UseMedicationCatalogArgs) => {
  const isCanvas = dataSource === CANVAS_TITLE;

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery] = useDebouncedValue(searchQuery);

  const rxNormLookup = useMedicationLookup({
    selectedDisplayName: isCanvas ? "" : selectedDisplayName,
    selectedSpecificDrugName: isCanvas ? "" : selectedSpecificDrugName,
  });

  const canvasQuery = useCanvasMedicationsQuery({
    query: isCanvas ? debouncedSearchQuery : undefined,
  });

  if (!isCanvas) {
    return {
      isCanvas,
      searchQuery,
      setSearchQuery,
      allDisplayNames: rxNormLookup.allDisplayNames,
      specificDrugOptions: rxNormLookup.specificDrugOptions,
      rxNormCode: rxNormLookup.rxNormCode,
      ndcCodes: rxNormLookup.ndcCodes,
      isLoadingSpecificDrugs: rxNormLookup.isLoadingSpecificDrugs,
    };
  }

  const canvasOptions = canvasMedicationOptions(canvasQuery.data?.data);

  return {
    isCanvas,
    searchQuery,
    setSearchQuery,
    allDisplayNames: canvasOptions.map((option) => option.display),
    specificDrugOptions: [],
    rxNormCode: [],
    ndcCodes: [],
    isLoadingSpecificDrugs: canvasQuery.isLoading,
    canvasOptions,
  };
};
